export default (value, rule) => /^(\d+)$/.test(value.toString());



// WEBPACK FOOTER //
// ./src/utils/validate/methods/integer.js